/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest = {
  ledgerCanisterId: string;
  offset?: number | undefined;
  limit?: number | undefined;
  maxAccountIndex?: number | undefined;
  /**
   * <I>Available values</I> : id, -id, total_transactions, -total_transactions, created_timestamp, -created_timestamp
   */
  sortBy?: Array<string> | undefined;
};

/** @internal */
export const ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema:
  z.ZodType<
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    max_account_index: z.number().int().optional(),
    sort_by: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "max_account_index": "maxAccountIndex",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    offset: number;
    limit: number;
    max_account_index?: number | undefined;
    sort_by?: Array<string> | undefined;
  };

/** @internal */
export const ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema:
  z.ZodType<
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$Outbound,
    z.ZodTypeDef,
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    maxAccountIndex: z.number().int().optional(),
    sortBy: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      maxAccountIndex: "max_account_index",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$ {
  /** @deprecated use `ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema;
  /** @deprecated use `ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema;
  /** @deprecated use `ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$Outbound` instead. */
  export type Outbound =
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$Outbound;
}

export function listAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequestToJSON(
  listAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest:
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest,
): string {
  return JSON.stringify(
    ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema
      .parse(listAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest),
  );
}

export function listAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListAccountsApiV1LedgersLedgerCanisterIdAccountsGetRequest' from JSON`,
  );
}
